import { render, staticRenderFns } from "./ListBnPrimClient.vue?vue&type=template&id=ef7d8476&scoped=true&"
import script from "./ListBnPrimClient.vue?vue&type=script&lang=js&"
export * from "./ListBnPrimClient.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef7d8476",
  null
  
)

export default component.exports